<template>
  <div class="fx-component-upload-file-item">
    <div v-if="type=='upload'" class="progress" :style="{width: percentValue+'%'}"></div>
    <div class="file-container">
      <div class="left">
        <span>
          <template v-if="$slots['file-icon']&&$slots['file-icon'].length>0">
            <slot name="file-icon"></slot>
          </template>
          <i v-else class="iconfont icon-fx-component-file"></i>
        </span>
        <span class="title">{{title}}</span>
      </div>
      <div class="right">
        <span @click="command('success')" v-if="type=='success'">
          <template v-if="$slots['success-icon']&&$slots['success-icon'].length>0">
            <slot name="success-icon"></slot>
          </template>
          <i v-else class="iconfont icon-fx-component-wancheng"></i>
        </span>
        <span class="upload-handle" v-if="type=='upload'">
          <!-- <template v-if="$slots['upload-icon']&&$slots['upload-icon'].length>0">
            <slot name="upload-icon"></slot>
          </template>-->
          <i @click="command('upload|close')" class="iconfont icon-fx-component-guanbi close"></i>
          <!-- <i
            v-if="pauseStatus"
            @click="resumeClick('upload|resume')"
            class="iconfont icon-zhihang resume"
          ></i>
          <i
            v-if="!pauseStatus"
            @click="pauseClick('upload|pause')"
            class="iconfont icon-icon-- pause"
          ></i> -->
        </span>
        <span @click="command('fail')" v-if="type=='fail'">
          <template v-if="$slots['fail-icon']&&$slots['fail-icon'].length>0">
            <slot name="fail-icon"></slot>
          </template>
          <i v-else class="iconfont icon-fx-component-zhongxinshangchuan"></i>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "file-item",
  props: {
    type: {
      type: String,
      default: "success",
      required: false
    },
    percent: {
      type: Number,
      default: 0,
      required: false
    },
    title: {
      type: String,
      default: "",
      required: true
    }
  },
  watch: {
    percent(val) {
      if (val > 100) {
        this.percentValue = 100;
      } else {
        this.percentValue = val;
      }
    }
  },
  data() {
    return {
      percentValue: this.percent,
      pauseStatus: false
    };
  },
  mounted() {},
  methods: {
    command(type) {
      this.$emit("command", type);
    },
    pauseClick(type) {
      this.pauseStatus = true;
      this.command(type);
    },
    resumeClick(type) {
      this.pauseStatus = false;
      this.command(type);
    }
  }
};
</script>
<style lang="scss" scoped>
.fx-component-upload-file-item {
  height: 50px;
  position: relative;
  .upload-handle {
    position: relative;
    .close {
      position: absolute;
      left: 30px;
      top: -1px;
      cursor: pointer;
    }
    .resume,
    .pause {
      position: absolute;
      top: -4px;
      left: 0;
      cursor: pointer;
    }
  }
  .file-container {
    padding: 0 70px 0 20px;
    display: flex;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    font-family: "pingfang-biaozhun", "PingFangSC-Regular";
    font-size: 12px;
    .left {
      display: flex;
      align-items: center;
      flex-grow: 1;
      flex-shrink: 1;
      box-flex: 1;
      .title {
        margin-left: 10px;
        color: #242424;
      }
    }
    .right {
      flex-grow: 0;
      flex-shrink: 0;
      box-flex: 0;
      font-size: 12px;
      .iconfont {
        cursor: pointer;
      }
      .icon-fx-component-wancheng {
        color: #7bcb2f;
        font-size: 12px;
      }
      .icon-fx-component-guanbi {
        color: #666666;
        font-size: 12px;
      }
      .icon-fx-component-zhongxinshangchuan {
        color: #3e7fff;
        font-size: 16px;
      }
    }
  }
  .progress {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 998;
    background-color: #f2f9ff;
  }
  .icon-fx-component-file {
    color: #242424;
    font-size: 20px;
  }
}
</style>

